import { Chess } from 'chess.js';

export function applyNullMove(chess: Chess): void {
  const fields = chess.fen().split(' ') as [string, string, string, string, string, string];

  if (fields.length !== 6) return;

  const [board, turn, castling, , halfmove, fullmove] = fields;

  const nextFen = [
    board,
    turn === 'b' ? 'w' : 'b',
    castling,
    '-', // сброс en passant
    String(parseInt(halfmove, 10) + 1), // ни взятия, ни хода пешкой — увеличиваем
    String(parseInt(fullmove, 10) + (turn === 'b' ? 1 : 0)), // увеличиваем для чёрных
  ].join(' ');

  chess.load(nextFen, { skipValidation: true });
}
